import { render, staticRenderFns } from "./CbbFormulierForm.vue?vue&type=template&id=15cf08ae"
import script from "./CbbFormulierForm.vue?vue&type=script&lang=js"
export * from "./CbbFormulierForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports